import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserRequest } from "../redux/reducer/UserReducer";
import Header from "../compnents/Header";

function User() {
  const dispatch = useDispatch();
  const { userData, isLoading, error } = useSelector((state) => state.UserReducer);
  const AuthReducer=useSelector(state=>state.AuthReducer);
  // console.log(AuthReducer.loginResponse.data.user_id,"?????action")
//   console.log(userData?.data?.user_name)

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    console.log("user:::", userId)
    if (userId) {
      dispatch(getUserRequest({user_id:AuthReducer.loginResponse.data.user_id}));
    } else {
      console.warn("User ID not found in localStorage.");
    }
  }, [dispatch]);

  return (
    <>
    <Header/>
    <div style={{ padding: "2rem" }}>
      {isLoading ? (
        <p>Loading user data...</p> 
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : userData ? (
        <p>Welcome, {userData?.data?.user_name}</p>
      ) : (
        <p>No user data found.</p>
      )}
    </div>
    </>
  );
}

export default User;
